import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { getLocalData } from "@/utils/sessionData.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    meta: {
      title: "登录页"
    },
    component: () => import("@/views/login/login.vue")
  },
  //我的页面
  {
    path: "/user",
    name: "user",
    meta: {
      title: "我的"
    },
    component: () => import("@/views/menu/user/index.vue")
  },
  {
    path: "/home",
    name: "home",
    meta: {
      title: "首页"
    },
    component: () => import("@/views/menu/home.vue")
  },
  {
    path: "/document/documentList",
    name: "documentList",
    meta: {
      title: "公文列表"
    },
    component: () => import("@/views/document/documentList.vue")
  },
  {
    path: '/document/documentListDetail',
    name: 'documentListDetail',
    meta: {
      title: "公文详情"
    },
    component: () => import('@/views/document/documentListDetail.vue'),
  },
  {
    path: '/document/addDocument',
    name: 'addDocument',
    meta: {
      title: "新建公文"
    },
    component: () => import('@/views/document/addDocument.vue'),
  },
  {
    path: '/document/shenDocument',
    name: 'shenDocument',
    meta: {
      title: "公文批示列表"
    },
    component: () => import('@/views/document/shenDocument.vue'),
  },
  {
    path: '/document/shenDocumentDetail',
    name: 'shenDocumentDetail',
    meta: {
      title: "公文批示"
    },
    component: () => import('@/views/document/shenDocumentDetail.vue'),
  },
  {
    path: '/document/proposedDocumentList',
    name: 'proposedDocumentList',
    meta: {
      title: "公文拟办列表"
    },
    component: () => import('@/views/document/proposedDocumentList.vue'),
  },
  {
    path: '/document/proposedDocumentListDetail',
    name: 'proposedDocumentListDetail',
    meta: {
      title: "公文拟办"
    },
    component: () => import('@/views/document/proposedDocumentListDetail.vue'),
  },
  {
    path: '/document/proposedDocumentListEdit',
    name: 'proposedDocumentListEdit',
    meta: {
      title: "修改拟办"
    },
    component: () => import('@/views/document/proposedDocumentListEdit.vue'),
  },
  {
    path: '/document/deptDocumentList',
    name: 'deptDocumentList',
    meta: {
      title: "公文查阅列表"
    },
    component: () => import('@/views/document/deptDocumentList.vue'),
  },
  {
    path: '/document/deptDocumentListDetail',
    name: 'deptDocumentListDetail',
    meta: {
      title: "公文查阅详情"
    },
    component: () => import('@/views/document/deptDocumentListDetail.vue'),
  },
  {
    path: '/document/archiveDocumentList',
    name: 'archiveDocumentList',
    meta: {
      title: "公文归档列表"
    },
    component: () => import('@/views/document/archiveDocumentList.vue'),
  },
  {
    path: "/procedure/addProcedure",
    name: "addProcedure",
    meta: {
      title: "新增流程"
    },
    component: () => import("@/views/procedure/addProcedure.vue")
  },
  {
    path: "/procedure/procedureList",
    name: "procedureList",
    meta: {
      title: "我的申请"
    },
    component: () => import("@/views/procedure/procedureList.vue")
  },
  {
    path: '/procedure/archiveList',
    name: 'archiveList',
    meta: {
      title: "流程归档列表"
    },
    component: () => import('@/views/procedure/archiveList.vue'),
  },
  {
    path: '/procedure/shenList',
    name: 'shenList',
    meta: {
      title: "流程审批列表"
    },
    component: () => import('@/views/procedure/shenList.vue'),
  },
  {
    path: '/procedure/leaderShenList',
    name: 'leaderShenList',
    meta: {
      title: "领导流程审批列表"
    },
    component: () => import('@/views/procedure/leaderShenList.vue'),
  },

  {
    path: '/procedure/noHandleList',
    name: 'noHandleList',
    meta: {
      title: "领导未审批列表"
    },
    component: () => import('@/views/procedure/noHandleList.vue'),
  },
  {
    path: '/procedure/passList',
    name: 'passList',
    meta: {
      title: "领导已审批列表"
    },
    component: () => import('@/views/procedure/passList.vue'),
  },
  {
    path: '/procedure/nopassList',
    name: 'nopassList',
    meta: {
      title: "领导审批未通过列表"
    },
    component: () => import('@/views/procedure/nopassList.vue'),
  },

  {
    path: "/procedure/addHoliday",
    name: "addHoliday",
    meta: {
      title: "新增请假"
    },
    component: () => import("@/views/procedure/addHoliday.vue")
  },
  {
    path: "/procedure/holidayListDetail",
    name: "holidayListDetail",
    meta: {
      title: "请假详情"
    },
    component: () => import("@/views/procedure/holidayListDetail.vue")
  },
  {
    path: '/procedure/shenHolidayDetail',
    name: 'shenHolidayDetail',
    meta: {
      title: "请假审批"
    },
    component: () => import('@/views/procedure/shenHolidayDetail.vue'),
  },
  {
    path: "/procedure/addOfficialVehicles",
    name: "addOfficialVehicles",
    meta: {
      title: "新增公务用车"
    },
    component: () => import("@/views/procedure/addOfficialVehicles.vue")
  },
  {
    path: "/procedure/officialVehiclesListDetail",
    name: "officialVehiclesListDetail",
    meta: {
      title: "公务用车详情"
    },
    component: () => import("@/views/procedure/officialVehiclesListDetail.vue")
  },
  {
    path: '/procedure/shenOfficialVehiclesDetail',
    name: 'shenOfficialVehiclesDetail',
    meta: {
      title: "公务用车审批"
    },
    component: () => import('@/views/procedure/shenOfficialVehiclesDetail.vue'),
  },
  {
    path: "/procedure/addRepairVehicle",
    name: "addRepairVehicle",
    meta: {
      title: "新增车辆维修"
    },
    component: () => import("@/views/procedure/addRepairVehicle.vue")
  },
  {
    path: "/procedure/repairVehicleListDetail",
    name: "repairVehicleListDetail",
    meta: {
      title: "车辆维修详情"
    },
    component: () => import("@/views/procedure/repairVehicleListDetail.vue")
  },
  {
    path: "/procedure/shenRepairVehicleDetail",
    name: "shenRepairVehicleDetail",
    meta: {
      title: "车辆维修审批"
    },
    component: () => import("@/views/procedure/shenRepairVehicleDetail.vue")
  },
  {
    path: "/procedure/addUseSeal",
    name: "addUseSeal",
    meta: {
      title: "新增用印"
    },
    component: () => import("@/views/procedure/addUseSeal.vue")
  },
  {
    path: "/procedure/useSealListDetail",
    name: "useSealListDetail",
    meta: {
      title: "用印详情"
    },
    component: () => import("@/views/procedure/useSealListDetail.vue")
  },
  {
    path: "/procedure/shenUseSealDetail",
    name: "shenUseSealDetail",
    meta: {
      title: "用印审批"
    },
    component: () => import("@/views/procedure/shenUseSealDetail.vue")
  },
  {
    path: "/procedure/addOutSeal",
    name: "addOutSeal",
    meta: {
      title: "新增印章外出"
    },
    component: () => import("@/views/procedure/addOutSeal.vue")
  },
  {
    path: "/procedure/shenOutSealDetail",
    name: "shenOutSealDetail",
    meta: {
      title: "印章外出审批"
    },
    component: () => import("@/views/procedure/shenOutSealDetail.vue")
  },
  {
    path: "/procedure/outSealListDetail",
    name: "outSealListDetail",
    meta: {
      title: "印章外出详情"
    },
    component: () => import("@/views/procedure/outSealListDetail.vue")
  },
  {
    path: "/procedure/apppurchased",
    name: "apppurchased",
    meta: {
      title: "新增物品采购申请"
    },
    component: () => import("@/views/procedure/apppurchased.vue")
  },
  {
    path: "/procedure/purchasedListDetail",
    name: "purchasedListDetail",
    meta: {
      title: "物品采购申请详情"
    },
    component: () => import("@/views/procedure/purchasedListDetail.vue")
  },
  {
    path: "/procedure/shenPurchasedDetail",
    name: "shenPurchasedDetail",
    meta: {
      title: "物品采购申请审批"
    },
    component: () => import("@/views/procedure/shenPurchasedDetail.vue")
  },
  {
    path: "/procedure/appreceived",
    name: "appreceived",
    meta: {
      title: "新增物品领用申请"
    },
    component: () => import("@/views/procedure/appreceived.vue")
  },
  {
    path: "/procedure/receivedListDetail",
    name: "receivedListDetail",
    meta: {
      title: "物品领用申请详情"
    },
    component: () => import("@/views/procedure/receivedListDetail.vue")
  },
  {
    path: "/procedure/shenReceivedDetail",
    name: "shenReceivedDetail",
    meta: {
      title: "物品领用申请审批"
    },
    component: () => import("@/views/procedure/shenReceivedDetail.vue")
  },
  {
    path: "/procedure/addOverTime",
    name: "addOverTime",
    meta: {
      title: "新增加班/调休"
    },
    component: () => import("@/views/procedure/addOverTime.vue")
  },
  {
    path: "/procedure/overTimeListDetail",
    name: "overTimeListDetail",
    meta: {
      title: "加班/调休详情"
    },
    component: () => import("@/views/procedure/overTimeListDetail.vue")
  },
  {
    path: '/procedure/shenOverTimeDetail',
    name: 'shenOverTimeDetail',
    meta: {
      title: "加班/调休审批"
    },
    component: () => import('@/views/procedure/shenOverTimeDetail.vue'),
  },
  {
    path: "/procedure/filePreview",
    name: "filePreview",
    meta: {
      title: "附件详情"
    },
    component: () => import("@/views/procedure/filePreview.vue")
  },
  {
    path: "/meeting/addMeeting",
    name: "addMeeting",
    meta: {
      title: "新增会议"
    },
    component: () => import("@/views/meeting/addMeeting.vue")
  },
  {
    path: "/meeting/meetingList",
    name: "meetingList",
    meta: {
      title: "会议台账"
    },
    component: () => import("@/views/meeting/meetingList.vue")
  },
  {
    path: "/meeting/meetingListDetail",
    name: "meetingListDetail",
    meta: {
      title: "会议详情"
    },
    component: () => import("@/views/meeting/meetingListDetail.vue")
  },
  {
    path: "/meeting/meetingNoticeList",
    name: "meetingNoticeList",
    meta: {
      title: "会议通知"
    },
    component: () => import("@/views/meeting/meetingNoticeList.vue")
  },
];
const originPush = VueRouter.prototype.push;
// 覆盖原型链的push
VueRouter.prototype.push = function(location, resolve, reject) {
  // this:路由实例对象

  // 判断用户有没有传后面两个可选参数
  if (resolve || reject) {
    return originPush.call(this, location, resolve, reject);
  } else {
    // 用户只传了第一个参数
    /*
    默认底层： catch()方法代码  throw err : 抛出异常
    吞掉报错原理： 重写catch()方法,把默认底层的 throw err给去掉，就不会抛出异常
    */
    return originPush.call(this, location).catch(err => {
      //  throw err
    });
  }
};
const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  const name = to.name;
  const token = getLocalData("token");
  const noTokenPage = ['login','siteReport','success']
  /*
    name != "login" &&
    name != "success"
     */
  if (
    !token && (name in noTokenPage)
  ) {
    next("/");
  } else {
    next();
  }
});
export default router;
